import PublicPackageApi from '@/api/public';


export default {
  namespaced: true,
  state: {
    reportBuffer: [],
    meta: {},
    loading: false,
    error: null,
  },

  actions: {
    async exportPdf(ctx, sensorUid) {
      ctx.commit('setLoading', true);
      ctx.commit('setError', null);
      try {
        let { data } = await PublicPackageApi.exportPdf(sensorUid);

        console.log('data', data);
        ctx.commit('setReportBuffer', data);
      } catch (error) {
        console.log('error', error);
        ctx.dispatch('errors/pushError', { id: 'packageDetails/report', error: error.message }, { root: true });
        ctx.commit('setError', error);
      } finally {
        ctx.commit('setLoading', false);
      }
    },
  },

  mutations: {
    setLoading(state, value) {
      state.loading = value;
    },

    setError(state, err) {
      state.error = err;
    },

    setMeta(state, meta) {
      state.meta = meta;
    },

    setReportBuffer(state, data) {
      state.reportBuffer = data;
    },
  },

  getters: {
    meta: state => state.meta,
    error: state => state.error,
    loading: state => state.loading,
    reportBuffer: state => state.reportBuffer,
  }
};
